import * as React from "react"
import {
  Button,
  ListGroup,
  ListGroupItem,
  Alert,
  Collapse,
  DropdownToggle,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Row,
  Col
} from "shards-react"

import Select from "react-select"
import Flag from "../common/flag"
import { isMobile } from "react-device-detect"

// Video Resources
import StudentVideo from "../videos/csec.mp4"

import { Pane, Text, majorScale, Autocomplete, TextInput } from "evergreen-ui"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"
import { getCountryNames } from "../js/getCountryNames"

import { getAllActiveCountries } from "../js/getAllActiveCountries"
import makeAnimated from "react-select/animated"

import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

import $ from "jquery"

// Icons
import GlobeIcon from "../icons/globe"

class Switcher extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.dismiss = this.dismiss.bind(this)
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.setRedirect = this.setRedirect.bind(this)

    this.state = {
      collapse: false,
      open: false,
      visible: true,
      href: "",
      selected: "",
      routes: require("../data/routes.json"),
      country: getCountry(this.props.countryCode),
      countries: getAllActiveCountries()
    }
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse })
  }

  // Toggeles the mobile dropdown to switch country
  toggleDropdown() {
    this.setState(prevState => {
      return { open: !prevState.open }
    })
  }

  dismiss() {
    this.setState({ visible: false })
  }

  handleChange = country => {
    this.setState({ selected: country }, () => this.setRedirect())

    $("#btn-change-country").click()
  }

  setRedirect(e) {
    this.state.countries.forEach(country => {
      if (this.state.selected === country.name) {
        this.setState({ countryCode: country.code, href: country.href })
      }
    })
  }

  render() {
    const { open } = this.state
    const animatedComponents = makeAnimated()

    const MainBodySwitcher = () => (
      <>
        <Row>
          <Col md={6}>
            <br />

            <video
              className={isMobile ? "break-container" : ""}
              style={{ width: "100%" }}
              preload="auto"
              autoPlay={true}
              loop
              muted
            >
              <source src={StudentVideo} type="video/mp4" />
            </video>
          </Col>
          <Col md={6}>
            <br />
            <BrowserView>
              <br />
            </BrowserView>
            <div className="text-center">
              <h4>Please select your country</h4>
              <p>See the courses and content that's offered in your country.</p>

              <br />
            </div>

            <Autocomplete
              title="Countries"
              className="form-control"
              onChange={changedItem => this.handleChange(changedItem)}
              items={getCountryNames()}
            >
              {props => {
                const { getInputProps, getRef, inputValue } = props
                return (
                  <TextInput
                    required
                    height={40}
                    className="form-control"
                    placeholder="Choose your country"
                    onChange={this.handleChange}
                    ref={getRef}
                    style={{ width: "100%" }}
                    {...getInputProps()}
                  />
                )
              }}
            </Autocomplete>

            <br />
            <Button
              outline={!this.state.href}
              className="text-center center"
              id="btn-change-country"
              href={this.state.href}
              style={{ width: "75%" }}
            >
              <span className="ml-2 ">
                {this.state.selected
                  ? "Switch to " + this.state.selected + " site"
                  : "Choose your country"}
              </span>

              <br />
            </Button>
          </Col>
        </Row>
      </>
    )

    const ListItem = props => (
      <Flag asDropdown showName countryCode={props.countryCode} />
    )

    const HeaderSwitcher = () => (
      <div style={{ display: "flex" }}>
        <Dropdown
          className="d-table"
          open={this.state.open}
          toggle={this.toggleDropdown}
        >
          <DropdownToggle
            style={{
              backgroundColor: "white",
              border: "white",
              width: "auto"
            }}
            className="text-dark"
          >
            {this.props.countryCode ? (
              <React.Fragment>
                <Flag
                  shortName
                  removeLink
                  style={{ width: "20px" }}
                  countryCode={this.props.countryCode}
                  alt={this.state.country.name}
                  className="ml-5"
                />
                <div>
                  {/* Displays the country name */}
                  {this.props.hideName ? (
                    <>
                      {this.state.country.short_name}
                      <i class="bi bi-caret-down-fill ml-1"></i>
                    </>
                  ) : null}
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                Select Country
                <i class="bi bi-caret-down-fill ml-1"></i>
              </React.Fragment>
            )}
          </DropdownToggle>

          <DropdownMenu right>
            {this.state.countries.map(country => (
              <ListItem key={country.id} countryCode={country.countryCode} />
            ))}
            <small className="text-center center">
              Flags by{" "}
              <a href="http://vectorflags.com" target="_blank">
                Vectorflags.com
              </a>
            </small>
          </DropdownMenu>
        </Dropdown>
      </div>
    )

    const BodySwitcher = () => (
      <div>
        <Alert
          theme="success"
          className={isMobile ? "break-container" : ""}
          dismissible={this.dismiss}
          open={this.state.visible}
        >
          <p>
            You are viewing the{" "}
            {this.state.country.pronoun || this.state.country.name || "Global"}{" "}
            version of our website. Not in{" "}
            {this.state.country.name ||
              "Want to see what's offered in your country"}
            ?
            <a className="pl-1" onClick={this.toggle}>
              <strong>Change country</strong>
            </a>
            .
          </p>
        </Alert>
        <Collapse open={this.state.collapse}>
          <ListGroup>
            {this.state.countries.map(country => (
              <ListGroupItem>
                <Flag
                  shortName
                  removeLink
                  style={{ width: "20px" }}
                  countryCode={country.countryCode}
                  alt={this.state.country.name}
                />
                <a
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="pl-3 text-primary"
                  href={country.href}
                >
                  {country.name}
                </a>
              </ListGroupItem>
            ))}
          </ListGroup>
        </Collapse>
      </div>
    )
    return (
      <>
        {this.props.body ? (
          <BodySwitcher />
        ) : this.props.header ? (
          <HeaderSwitcher />
        ) : !this.props.hidden ? (
          <MainBodySwitcher />
        ) : (
          <MainBodySwitcher />
        )}
      </>
    )
  }
}

export default Switcher
